export const CURRENCY_META = {
  GBP: { symbol: '£', decimals: 2 },
  EUR: { symbol: '€', decimals: 2 },
  USD: { symbol: '$', decimals: 2 },
  AUD: { symbol: 'A$', decimals: 2 },
  CAD: { symbol: 'C$', decimals: 2 },
  NZD: { symbol: 'NZ$', decimals: 2 },
  CHF: { symbol: 'CHF', decimals: 2 },
  SEK: { symbol: 'kr', decimals: 2 },
  NOK: { symbol: 'kr', decimals: 2 },
  DKK: { symbol: 'kr', decimals: 2 },
  JPY: { symbol: '¥', decimals: 0 },
  KRW: { symbol: '₩', decimals: 0 },
  VND: { symbol: '₫', decimals: 0 },
};

function normalizeCountry(value = '') {
  return String(value)
    .trim()
    .toLowerCase()
    .replace(/\./g, '')
    .replace(/\s+/g, ' ');
}

const COUNTRY_TO_CURRENCY = {
  uk: 'GBP',
  gb: 'GBP',
  'united kingdom': 'GBP',
  'great britain': 'GBP',
  britain: 'GBP',
  england: 'GBP',
  scotland: 'GBP',
  wales: 'GBP',
  'northern ireland': 'GBP',

  us: 'USD',
  usa: 'USD',
  'united states': 'USD',
  'united states of america': 'USD',

  au: 'AUD',
  australia: 'AUD',

  nz: 'NZD',
  'new zealand': 'NZD',

  ca: 'CAD',
  canada: 'CAD',

  ie: 'EUR',
  ireland: 'EUR',
  at: 'EUR',
  austria: 'EUR',
  be: 'EUR',
  belgium: 'EUR',
  cy: 'EUR',
  cyprus: 'EUR',
  ee: 'EUR',
  estonia: 'EUR',
  fi: 'EUR',
  finland: 'EUR',
  fr: 'EUR',
  france: 'EUR',
  de: 'EUR',
  germany: 'EUR',
  gr: 'EUR',
  greece: 'EUR',
  it: 'EUR',
  italy: 'EUR',
  lv: 'EUR',
  latvia: 'EUR',
  lt: 'EUR',
  lithuania: 'EUR',
  lu: 'EUR',
  luxembourg: 'EUR',
  mt: 'EUR',
  malta: 'EUR',
  nl: 'EUR',
  netherlands: 'EUR',
  pt: 'EUR',
  portugal: 'EUR',
  sk: 'EUR',
  slovakia: 'EUR',
  si: 'EUR',
  slovenia: 'EUR',
  es: 'EUR',
  spain: 'EUR',
};

export function getDefaultCurrencyForCountry(country, fallback = 'GBP') {
  const key = normalizeCountry(country);
  if (!key) return fallback;
  return COUNTRY_TO_CURRENCY[key] || fallback;
}

export function sortCurrencyOptions(options, preferred) {
  const unique = Array.from(new Set(options || []));
  if (!preferred || !unique.includes(preferred)) return unique;
  return [preferred, ...unique.filter((c) => c !== preferred)];
}

export function getCurrencyMeta(code) {
  return CURRENCY_META[code] || { symbol: '', decimals: 2 };
}
